<template>
  <div class="space-between-y">
    <div class="space-between-x container-left">
      <el-input v-model="form.name" placeholder="请输入新增分组名称" clearable></el-input>
      <el-button @click="handlerCreate" type="primary">添加分组</el-button>
    </div>

    <el-table :data="list" stripe border>
      <el-table-column type="index" label="#" width="60"></el-table-column>
      <el-table-column prop="name" label="标签名称"></el-table-column>
      <el-table-column prop="imgCount" width="110" label="精彩瞬间数量"></el-table-column>
      <el-table-column label="操作" width="180" align="center">
        <template v-slot="{row}">
          <el-button size="mini" type="text" @click="handlerUpdate(row)">修改</el-button>
          <el-button type="text" size="mini" @click="handlerDel(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {eventorder} from "@/api/eventorder";
import {msg} from "@/assets/js/my-vue-element-ui-js";
import EventOrderDetail from "@/components/eventorder/EventOrderDetail.vue";


export default {
  name: 'EventOrderTag',
  components: {EventOrderDetail},

  props: {
    id: Number
  },

  created() {
    console.log("EventOrderTag created");
    this.getData();
  },

  data() {
    return {
      list: [],

      form: {
        name: "",
      },
    }
  },


  methods: {
    handlerCreate() {
      eventorder.createEventTag(this.id, this.form.name).then(res => {
        msg(res, this);
        if (res.code === 200) {
          this.form.name = "";
          this.getData();
        }
      })
    },

    handlerUpdate(tag) {
      this.$prompt("请输入分组名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: "标签名称长度1-20",
        inputValue: tag.name
      }).then(({value}) => {
        eventorder.updateEventTag(tag.id, value).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })
      })

    },
    handlerDel(tag) {
      this.$confirm("执行操作后，该分组内的所有图片/视频，将会删除，确定操作吗？").then(() => {
        eventorder.deleteEventTag(tag.id).then(res => {
          msg(res, this);
          if (res.code === 200) {
            this.getData();
          }
        })
      })
    },

    getData() {
      eventorder.listEventTag(this.id).then(res => {
        this.list = res.data;
      })
    },
  },


};
</script>

<style scoped>
</style>